// eslint-disable-next-line no-restricted-imports
import { Container } from 'dripsy';

export default Container;
